export default __webpack_public_path__ + "static/media/party2.ce67617e.jpg";